import isPropValid from '@emotion/is-prop-valid';
import styled, { css } from 'styled-components';
import { colors, spacing } from '../../style';
import { actionColor, inputBorderColor } from '../../style/theme-helpers';
import { MultiComboboxProps } from './multi-combobox';

export const dropdownSizes = {
  auto: {
    width: 'auto',
  },
  md: {
    width: '260px',
  },
};

export const dropdownVariants = {
  default: css`
    box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.24);
    border: 1px solid ${colors.gray100};
  `,
  clean: css``,
};
export const MultiSelectionComponentWrapper = styled.div.withConfig({ shouldForwardProp: isPropValid })<{
  dropdownVariant: keyof typeof dropdownVariants;
  menuMode?: MultiComboboxProps['menuMode'];
}>`
  .combobox-wrapper {
    position: relative;

    .buttons {
      position: absolute;
      right: 8px;
      top: 4px;
      display: flex;
      align-items: center;

      .spinner {
        position: relative;
        top: 10px;
        left: -2px;
      }

      button[disabled] {
        background: ${colors.gray400};
        border: none;
      }
    }

    input {
      display: block;
      width: 100%;
      background: ${colors.white};
      border: 1px solid ${inputBorderColor};
      height: 40px;
      border-radius: 2px;
      padding: 8px 10px;
      font-size: 0.875rem;
      color: ${colors.gray900};
      cursor: pointer;

      &:focus:not([disabled]),
      &:active:not([disabled]),
      &:focus-visible:not([disabled]),
      &.active:not([disabled]) {
        border: 1px solid ${actionColor};
      }

      ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${colors.gray800};
        font-size: 1rem;

        opacity: 1; /* Firefox */
      }

      &[disabled] {
        ::placeholder {
          /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: ${colors.gray600};
          font-size: 1rem;

          opacity: 1; /* Firefox */
        }
      }

      &[disabled] {
        background: ${colors.gray100};
        cursor: not-allowed;
      }

      &:focus,
      &.focused {
        outline: none;
        cursor: text;
      }
    }
  }

  position: relative;

  .dropdown {
    list-style-type: none;
    margin: 0;
    border-radius: 2px;
    display: block;
    max-height: 240px;
    overflow-y: auto;
    width: 100%;
    background: ${colors.white};
    z-index: 1000;
    position: absolute;
    scroll-behavior: auto;

    ${props =>
      props.menuMode === 'static' &&
      css`
        padding: 0 !important;
        position: static;
        width: 100%;

        .menu-item {
          padding-left: 2px !important;
        }
      `}
    &.size-md {
      width: ${dropdownSizes.md.width};
    }

    &.open {
      padding: ${spacing.xs};

      ${props => dropdownVariants[props.dropdownVariant]}
      &:focus {
        outline: 0;
      }
    }
  }

  .menu-item {
    padding: ${spacing.xs};
    border-radius: 2px;
    transition: 0.3s;

    &:first-child {
      margin-top: 4px;
    }

    &:not([aria-disabled='true']) {
      cursor: pointer;
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    &[aria-disabled='true'] {
      cursor: not-allowed;
      opacity: 0.5;
    }

    &.highlighted {
      background: ${colors.gray100};

      &:active {
        background: ${props => props.theme.actionLight};
      }
    }

    .inner-item-container {
      display: flex;
      align-items: flex-start;
      flex-grow: 1;
      height: 100%;
      gap: ${spacing.xs};

      &.align-items-center {
        align-items: center;
      }

      .item-text {
        position: relative;
        width: 90%;
        display: block;
        word-break: break-word;
      }
    }
  }

  .toggle-button {
    &:not([disabled]) {
      cursor: pointer;
    }

    &[disabled] {
      cursor: not-allowed;
    }

    .toggle-icon {
      margin-left: auto;
    }
  }
`;
